<template>
  <!--
      作者 kmdshop
      时间：2020-9-25
      描述：设置-直播设置
  -->
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <!--直播设置-->
      <div class="common-form">直播设置</div>
      <el-form-item label="是否开启直播" prop="is_open"><el-switch v-model="formData.is_open"></el-switch></el-form-item>
      <el-form-item label="允许进入直播的用户等级">
        <el-select v-model="formData.detail" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import SettingApi from '@/api/live.js';
  export default{
    data(){
      return {
        /*是否正在加载*/
        loading:true,
        /*表单数据对象*/
        formData:{
          is_open:false,
          detail:[],
        },
        /*用户等级*/
        grade_list:[],
      }
    },
    created() {
      this.getParams();
    },
    methods:{

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.goLive({}, true).then(res => {
            if (res.code == 1) {
              self.formData=res.data.vars.values;
              self.grade_list = res.data.grade_list;
              self.loading=false;
            } else {
            }
          })
          .catch(error => {

          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.formData;
        self.$refs.formData.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.setLive(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你， 直播设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/live/wx/setting.vue